import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { db } from '../firebase'; // Import your database
import { collection, onSnapshot, query } from 'firebase/firestore';

// 1. Create the Context
const ProductContext = createContext();

// 2. Create a "hook" to use the context
export const useProducts = () => {
  return useContext(ProductContext);
};

// 3. Create the Provider component
export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // We use this to keep track of the delay timer so we can clean it up
  const timerRef = useRef(null); 

  // 4. Fetch products from Firestore on app load
  useEffect(() => {
    const productsCollection = collection(db, 'Products');
    const q = query(productsCollection);

    // onSnapshot listens for real-time updates
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const productsData = [];
      querySnapshot.forEach((doc) => {
        productsData.push({ id: doc.id, ...doc.data() });
      });

      // Clear any existing timer if the database updates
      if (timerRef.current) clearInterval(timerRef.current);

      const CHUNK_SIZE = 12; // How many products to show at first
      let currentlyShowing = CHUNK_SIZE;

      // Instantly show the first batch of products and stop the loading spinner
      setProducts(productsData.slice(0, currentlyShowing));
      setIsLoading(false);

      // If there are more products, slowly drip-feed them into the website
      if (productsData.length > currentlyShowing) {
        timerRef.current = setInterval(() => {
          currentlyShowing += CHUNK_SIZE; // Add 12 more
          
          setProducts(productsData.slice(0, currentlyShowing));

          // Once all products are loaded, stop the timer
          if (currentlyShowing >= productsData.length) {
            clearInterval(timerRef.current);
          }
        }, 600); // 600 milliseconds delay between each batch (Adjust this if you want it faster/slower!)
      }

    }, (error) => {
      console.error("Error fetching products:", error);
      setIsLoading(false);
    });

    // Cleanup the listener and the timer if the user leaves the site
    return () => {
      unsubscribe();
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []); 

  const value = {
    products,
    isLoading
  };

  return (
    <ProductContext.Provider value={value}>
      {children}
    </ProductContext.Provider>
  );
};